import 'globals';
import PageLoadedQueue from './PageLoadedQueue';
import LazyLoad from "vanilla-lazyload";

declare global {
    interface Window {
        lazyLoadObject: LazyLoad|undefined;
    }
}

const createLazyLoadObject = () => {
    if (typeof window.lazyLoadObject === 'undefined') {
        window.lazyLoadObject = new LazyLoad({
            elements_selector: '.img-fluid'
        });
    } else {
        window.lazyLoadObject.update();
    }
}

PageLoadedQueue.addFunction(createLazyLoadObject);
